const OPEN_CONTEXT_MENU = '@contextMenu/open';
const CLOSE_CONTEXT_MENU = '@contextMenu/close';

export { OPEN_CONTEXT_MENU, CLOSE_CONTEXT_MENU };
